import getYear from 'date-fns/get_year'
import { getField, updateField } from 'vuex-map-fields';

state =
    title: "" # search for title

getters = { getField }

mutations = {
    # mutations for the simple fields (like 'seen')
    updateField
}

export default {
    namespaced: true
    state
    getters
    mutations
}
